module.exports = __webpack_public_path__ + "img/lk.23e5cb5.svg";